import { IPartFinderReel } from 'partFinder/types';
import {
  ICustomerQuoteUpsertForm,
  mapCreateCustomerQuoteForm,
} from 'quotes/components/CustomerQuoteUpsert';
import { QuoteEntityType, QuotePartNoteType } from 'quotes/enums';
import {
  IAddFinderPartsToNewQuoteData,
  IAddFinderPartsToQuoteData,
  IBaseQuote,
  IFinderQuoteLine,
  IQuotePartNote,
} from 'quotes/types';

import { IAddReelsToQuoteForm, IReelLineForm } from './types';
import { getReelNote } from './utils';

export const getReelNotes = (reel: IPartFinderReel): Pick<IQuotePartNote, 'content' | 'type'>[] => {
  const reelNote = getReelNote(reel);

  return reelNote ? [{ type: QuotePartNoteType.INTERNAL, content: reelNote }] : [];
};

export const mapReelToFinderQuoteLine = (
  reel: IPartFinderReel,
  line: IReelLineForm
): IFinderQuoteLine => ({
  description: reel?.description ?? null,
  manufacturerId: reel?.manufacturerId,
  notes: getReelNotes(reel),
  partNumber: reel?.partNumber,
  quantity: Number(line?.quantity),
  uom: line?.uom,
});

interface IProps {
  reels: IPartFinderReel[];
  data: IAddReelsToQuoteForm;
  targetQuote?: IBaseQuote | null;
  entityType?: QuoteEntityType;
  isAlternateVersionEnabled?: boolean;
}

// Every line the shopper kept in the table, each with the reel it was picked from. Two reels of
// one part stay two lines, so each picked reel is quoted on its own.
export const mapAddReelsToQuoteForm = ({
  reels,
  data,
  targetQuote = null,
  entityType = QuoteEntityType.QUOTE,
  isAlternateVersionEnabled = false,
}: IProps): IAddFinderPartsToQuoteData | IAddFinderPartsToNewQuoteData => {
  const reelsByRowId = new Map((reels ?? []).map((reel) => [reel.id, reel]));

  const lines = (data?.lines ?? [])
    .filter((line) => reelsByRowId.has(line?.reelRowId))
    .map((line) => mapReelToFinderQuoteLine(reelsByRowId.get(line.reelRowId), line));

  if (targetQuote?.id) {
    return { lines, targetQuoteId: targetQuote.id };
  }

  return {
    lines,
    targetQuote: mapCreateCustomerQuoteForm(
      data as ICustomerQuoteUpsertForm,
      entityType,
      isAlternateVersionEnabled
    ).quote,
  };
};
